// taskForm.store.ts
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const DEFAULT_SUBJECT = 'matematika';

const initialValues: Record<string, unknown> = {
  selectedParticipants: [],
  studentType: '', // self-create defaults to 'graduated' in TaskWizardModal on open
  grades: [],

  studentName: '',
  isSelf: true,
  teacherGender: 'any',
  duration: null,
  locations: [],
  studyTime: { days: [], time_from: '', time_to: '' },
  comment: '',
  priceFrom: 500,
  priceTo: null,
  trial: null,
  subject: DEFAULT_SUBJECT,
  subjectLabel: 'Математика',

  goal: '',
  goalLabel: '',
  preferredTutorProfileId: null,
};

export const useTaskFormStore = create<{
  values: Record<string, unknown>;
  setValues: (values: Record<string, unknown>) => void;
  updateField: (key: string, value: unknown) => void;
  reset: () => void;
}>()(
  persist(
    (set) => ({
      values: initialValues,
      setValues: (values) => set({ values }),
      updateField: (key, value) =>
        set((state) => ({
          values: { ...state.values, [key]: value },
        })),
      reset: () => set({ values: initialValues }),
    }),
    {
      name: 'task-form-storage',
    },
  ),
);
